import { MappedAggregations, Aggregation } from 'src/components/CategoryListingPage/utils/cleanAggregations';

export const filterMappedAggregations = (mappedAggregations: MappedAggregations) =>
    new Map([...mappedAggregations].filter(([key, value]) => key !== 'export_filter_product_type'));

export const filterAggregations = (aggregations: Aggregation[]) =>
    aggregations.filter((aggregation) => aggregation.attribute_code !== 'export_filter_product_type');
